import type { ContributionAmountKind } from '@klear/constants/document-processing'
import { parseUnsafeMoney } from '@/app/document-review/unsafe-money'

export type ContributionDirection = 'sets' | 'adds' | 'reduces'

export type ContributionReading = {
  direction: ContributionDirection
  sentence: string
}

type Contribution = { amount: string | null; amountKind?: ContributionAmountKind | null }

export function readContribution(contribution: Contribution | null): ContributionReading | null {
  const money = parseUnsafeMoney(contribution?.amount)
  if (money === null) return null

  if (contribution?.amountKind === 'total') {
    return { direction: 'sets', sentence: `Sets the total to ${money.toString()}` }
  }
  const direction: ContributionDirection = money.isNegative() ? 'reduces' : 'adds'
  const magnitude = (money.isNegative() ? money.mul(-1n) : money).toString()
  const sentence = direction === 'reduces' ? `Reduces the record by ${magnitude}` : `Adds ${magnitude} to the record`

  return { direction, sentence }
}
